<template>
  <ModalDefault modal_id="logsUser"
                header="y"
                size="modal-xl modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_800')"
                footer=""
                icon="bx bx-history mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="row" v-if="logs.log.properties.attributes">
        <div v-if="logs.log.properties.old" class="col">
          <span>{{ getTranslations('expression_801') }}</span>
          <vue-code-highlight language="javascript">
            <pre>{{ logs.log.properties.old }}</pre>
          </vue-code-highlight>
        </div>
        <div class="col">
          <span v-if="logs.log.properties.old">{{ getTranslations('expression_802') }}</span>
          <vue-code-highlight language="javascript">
            <pre>{{ logs.log.properties.attributes }}</pre>
          </vue-code-highlight>
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import {component as VueCodeHighlight} from "vue-code-highlight";
import "vue-code-highlight/themes/duotone-sea.css";
import "vue-code-highlight/themes/window.css";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalLogsUser",
  components: {
    ModalDefault,
    VueCodeHighlight,
  },
  computed: {
    ...mapState(['logs']),
    ...mapGetters([])
  },
  methods: {
  }
}
</script>

<style scoped>

</style>

<style>
div pre[class*="language-"] {
  padding-left: 25px;
  padding-bottom: 15px;
  padding-top: 50px;
  width: 100%;
  border-radius: 15px !important;
  -webkit-box-shadow: none;
  box-shadow: none;
  overflow-x: auto!important;
  /*-webkit-box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1)!important;*/
  /*box-shadow: 0 5px 15px -2px rgba(0, 0, 0, 0.1)!important;;*/
}
</style>
